module.exports = __webpack_public_path__ + "img/clienti_edit.f64cdabf.png";